import styled, { useTheme } from "styled-components";
import { TabList, TabContext, TabPanel } from "@mui/lab";
import { Tab as MuiTab } from "@mui/material";
import { useEffect, useState } from "react";
import { Children } from "react";
import { useMobile } from "../../utils/mobile";

const StyleTabs = styled(TabList)(({ theme, mobile }) => ({
  flex: 1,

  [`&& .MuiButtonBase-root`]: {
    fontSize: mobile ? 14 : 20,
    fontWeight: mobile ? 500 : 600,
    color: theme.color.gray90,
    whiteSpace: "nowarp",
    maxWidth: mobile ? 200 : 500,
    padding: `12px 5px`,
  },
  [`&& .MuiTabs-flexContainer`]: {
    justifyContent: mobile && "center",
    gap: mobile ? "unset" : 40,
  },
  [`&& .MuiTabs-indicator`]: {
    color: `${theme.color.primary} !important`,
    backgroundColor: `${theme.color.primary} !important`,
    height: 4,
  },
  [`&& .Mui-selected`]: {
    color: `${theme.color.primary} !important`,
  },
}));

const Tab = ({ value, children }) => ({ children });

const Tabs = ({ value, tabChange, children }) => {
  const [tabValue, setTabValue] = useState(value);
  const arrayChildren = Children.toArray(children);
  const theme = useTheme();
  const isMobile = useMobile();

  const onTabChange = (event, newValue) => {
    tabChange(newValue);
    setTabValue(newValue);
  };

  useEffect(() => {
    setTabValue(value);
  }, [value]);

  return (
    <TabContext value={tabValue}>
      <div
        style={{
          borderBottom: 1,
          borderBlockEndStyle: "solid",
          borderColor: theme.color.gray30,
          display: "flex",
          justifyContent: "start",
        }}>
        <StyleTabs onChange={onTabChange} mobile={isMobile}>
          {Children.map(arrayChildren, (child, index) => {
            return (
              <MuiTab
                key={index}
                label={child.props.label}
                value={child.props.value}
              />
            );
          })}
        </StyleTabs>
      </div>
      {Children.map(arrayChildren, (child, index) => {
        return (
          <TabPanel key={index} value={child.props.value}>
            {child.props.children}
          </TabPanel>
        );
      })}
    </TabContext>
  );
};

export default Tabs;
export { Tab };
